import { ref, watch } from "vue";
export default function useCenterActiveTab(props) {
  const { slideRefs, activeSlide, totalWidth, containerWidth, swipeCooldown, mutableTranslateX } = props;
  const animationEnabled = ref(false);
  const isFocusVisible = ref(false);
  function getFocusVisible(element) {
    return element.matches(":focus-visible");
  }
  function checkFocusVisible() {
    if (!slideRefs.value) {
      return false;
    }
    return slideRefs.value.some((slide) => {
      const el = slide.root.$el || slide.root;
      return el && getFocusVisible(el);
    });
  }
  function centerActiveTab(tabValue) {
    if (swipeCooldown.value || totalWidth.value <= containerWidth.value) {
      return;
    }
    const index = slideRefs.value.findIndex((slide) => slide.root.value === tabValue);
    if (index === -1) {
      return;
    }
    const slideComponent = slideRefs.value[index];
    if (!slideComponent || !slideComponent.root) {
      return;
    }
    const el = slideComponent.root.$el || slideComponent.root;
    if (!el) {
      return;
    }
    animationEnabled.value = true;
    setTimeout(() => {
      animationEnabled.value = false;
    }, 300);
    const elOffsetLeft = el.offsetLeft;
    const elWidth = el.offsetWidth;
    const containerWidthValue = containerWidth.value;
    const newTranslateX = containerWidthValue / 2 - (elOffsetLeft + elWidth / 2);
    const maxTranslateX = 0;
    const minTranslateX = Math.min(containerWidthValue - totalWidth.value, 0);
    mutableTranslateX.value = Math.max(minTranslateX, Math.min(newTranslateX, maxTranslateX));
  }
  watch(activeSlide, () => {
    isFocusVisible.value = checkFocusVisible();
    if (isFocusVisible.value && activeSlide.value) {
      centerActiveTab(activeSlide.value);
    }
  });
  return {
    animationEnabled,
    centerActiveTab,
    isFocusVisible,
    checkFocusVisible
  };
}
